import Experience from "./src/Experience.js"

const canvas = document.querySelector('canvas.webgl')
const experience = new Experience(canvas)